import {css} from '@emotion/react'
import {useStaticQuery, graphql} from 'gatsby'

const translations = {
    en: {
        aboutUs: 'About Us',
        termsOfService: 'Terms of Service',
        privacyPolicy: 'Privacy Policy',
    },
    de: {
        aboutUs: 'Über uns',
        termsOfService: 'Nutzungsbedingungen',
        privacyPolicy: 'Datenschutzrichtlinie',
    },
    nl: {
        aboutUs: 'Over ons',
        termsOfService: 'Servicevoorwaarden',
        privacyPolicy: 'Privacybeleid',
    },
}

// eslint-disable-next-line no-unused-vars
const Footer = ({languageCode = 'en', experimentId, os, browser}) => {
    const text = translations[languageCode] || translations.en

    const images = useStaticQuery(graphql`
        query PrivateAIFooterImages {
            spLogo: file(relativePath: {eq: "startpage/sp-logo-3.svg"}) {
                publicURL
            }
            logo: file(relativePath: {eq: "startpage/logo.svg"}) {
                publicURL
            }
        }
    `)

    return (
        <footer
            className="sp-footer"
            css={css`
                width: 100%;
                height: 320px;
                background: linear-gradient(0deg, #000 0%, #29348C 113.21%);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 60px 20px;
                box-sizing: border-box;
                gap: 24px;
            `}
        >
            {/* Logo */}
            <div
                className="logo"
                css={css`
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-direction: column;
                    margin-bottom: 24px;
                `}
            >
                <img
                    src={images.spLogo.publicURL}
                    alt="Startpage Logo"
                    css={css`
                        width: 40px;
                        height: 40px;
                    `}
                />
                <img
                    src={images.logo.publicURL}
                    alt="Startpage"
                    css={css`
                        height: 25px;
                        width: auto;
                        margin-top: 8px;
                    `}
                />
            </div>

            {/* Footer Links */}
            <div
                className="footer-links"
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 28px;
                    align-items: center;
                `}
            >
                <a
                    href="https://www.startpage.com/en/about-us"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={css`
                        color: #F2F3FB;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: 'Inter';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 16px;
                        letter-spacing: 0.3px;
                        transition: color 0.3s ease;

                        &:hover {
                            color: #00ffee;
                        }
                    `}
                >
                    {text.aboutUs}
                </a>
                <a
                    href="/en/terms-privateai"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={css`
                        color: #f2f3fb;
                        text-decoration: none;
                        font-family: 'Inter';
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 16px;
                        letter-spacing: 0.3px;
                        transition: color 0.3s ease;

                        &:hover {
                            color: #00ffee;
                        }
                    `}
                >
                    {text.termsOfService}
                </a>
                <a
                    href="/en/privacy-policy-privateai"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={css`
                        color: #f2f3fb;
                        text-decoration: none;
                        font-family: 'Inter';
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 16px;
                        letter-spacing: 0.3px;
                        transition: color 0.3s ease;

                        &:hover {
                            color: #00ffee;
                        }
                    `}
                >
                    {text.privacyPolicy}
                </a>
            </div>
        </footer>
    )
}

export default Footer
